'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reactIntl = require('react-intl');

var _show_password = require('../../../res/images/icon/show_password.svg');

var _show_password2 = _interopRequireDefault(_show_password);

var _hide_password = require('../../../res/images/icon/hide_password.svg');

var _hide_password2 = _interopRequireDefault(_hide_password);

var _PasswordInput = require('./PasswordInput.scss');

var _PasswordInput2 = _interopRequireDefault(_PasswordInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PasswordInput = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(PasswordInput, _Component);

  function PasswordInput() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PasswordInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PasswordInput.__proto__ || (0, _getPrototypeOf2.default)(PasswordInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      passwordHidden: true
    }, _this.handlePasswordChange = function (event) {
      _this.props.editPassword(event.target.value);
      if (_this.props.handleOnChange) {
        _this.props.handleOnChange();
      }

      if (_this.props.error) {
        _this.props.handleErrorState(false);
      }
    }, _this.togglePasswordState = function () {
      _this.setState({ passwordHidden: !_this.state.passwordHidden });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PasswordInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          error = _props.error;
      var formatMessage = this.props.intl.formatMessage;

      var inputClassName = _PasswordInput2.default.password + (error ? ' ' + _PasswordInput2.default.error : '') + (className ? ' ' + className : '');
      return _react2.default.createElement(
        'div',
        { className: inputClassName },
        error ? _react2.default.createElement(
          'div',
          { className: _PasswordInput2.default.errorMessage },
          _react2.default.createElement(_reactIntl.FormattedMessage, this.props.errorString)
        ) : '',
        _react2.default.createElement('img', { className: _PasswordInput2.default.showIcon, src: this.state.passwordHidden ? _show_password2.default : _hide_password2.default, onClick: this.togglePasswordState }),
        _react2.default.createElement(_reactBootstrap.FormControl, {
          className: _PasswordInput2.default.passwordInput,
          name: this.props.name,
          type: this.state.passwordHidden ? 'password' : 'text',
          value: this.props.password,
          placeholder: formatMessage(this.props.placeholder),
          onBlur: this.props.handleOnBlur,
          onChange: this.handlePasswordChange,
          onKeyPress: this.props.handleEnterKey
        })
      );
    }
  }]);
  return PasswordInput;
}(_react.Component), _class.propTypes = {
  className: _react.PropTypes.string,
  editPassword: _react.PropTypes.func,
  password: _react.PropTypes.string,
  error: _react.PropTypes.bool,
  errorString: _react.PropTypes.object,
  intl: _reactIntl.intlShape.isRequired,
  handleEnterKey: _react.PropTypes.func,
  handleErrorState: _react.PropTypes.func,
  handleOnBlur: _react.PropTypes.func,
  handleOnChange: _react.PropTypes.func,
  name: _react.PropTypes.string,
  placeholder: _react.PropTypes.object.isRequired
}, _temp2);
exports.default = PasswordInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PasswordInput/PasswordInput.js
// module id = 1964
// module chunks = 0